import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FcSearchInputModule } from '../../base/fc-search-input/fc-search-input.module';
import { FcMaintenanceTypeInputComponent } from './fc-maintenance-type-input.component';


@NgModule({
  declarations: [
    FcMaintenanceTypeInputComponent
  ],
  imports: [
    FcSearchInputModule,
    TranslateModule
  ],
  exports: [
    FcMaintenanceTypeInputComponent
  ]
})
export class FcMaintenanceTypeModule {}
